// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';
import { RolesRoutingModule } from './roles-routing.module';

// Custom packages - Components
import { AddRoleComponent } from 'src/app/modules/roles/pages/add-role/add-role.page';
import { RoleDetailComponent } from 'src/app/modules/roles/pages/role-detail/role-detail.page';
import { RolesListComponent } from 'src/app/modules/roles/pages/roles-list/roles-list.page';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    RolesRoutingModule,
    PublicModule,
  ],
  declarations: [
    RolesListComponent,
    RoleDetailComponent,
    AddRoleComponent,
  ],
  exports: [
  ]
})
export class RolesModule { }
